const initialiseFaqCenter = (root) => {
  if (!root || root.dataset.ktFaqReady === 'true') return;

  const source = root.querySelector('template[data-kt-faq-source]');
  const target = root.querySelector('[data-kt-faq-list]');
  if (!source || !target) return;

  const fragment = source.content.cloneNode(true);
  fragment.querySelectorAll('script, style, link, meta, iframe, object, embed').forEach((node) => node.remove());

  const sourceHeading = fragment.querySelector('.faq-container h2, h2');
  const heading = sourceHeading?.textContent?.trim();
  if (heading) {
    const title = document.createElement('h2');
    title.className = 'kt-faq-page__category';
    title.textContent = heading;
    target.append(title);
  }

  const oldItems = [...fragment.querySelectorAll('.faq-item')];
  const nativeItems = [...fragment.querySelectorAll('details')];
  const items = oldItems.length ? oldItems : nativeItems;

  items.forEach((item, index) => {
    const question = oldItems.length
      ? item.querySelector('.faq-question')
      : item.querySelector('summary');
    const answer = oldItems.length
      ? item.querySelector('.faq-answer')
      : item.querySelector(':scope > :not(summary)');
    if (!question || !answer) return;

    const details = document.createElement('details');
    details.className = 'kt-faq-page__item';
    if (index === 0 && root.dataset.openFirst === 'true') details.open = true;

    const summary = document.createElement('summary');
    summary.className = 'kt-faq-page__question';
    const label = document.createElement('span');
    label.textContent = question.textContent.trim();
    const icon = document.createElement('span');
    icon.className = 'kt-faq-page__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '+';
    summary.append(label, icon);

    const body = document.createElement('div');
    body.className = 'kt-faq-page__answer rte';
    body.innerHTML = answer.innerHTML;
    body.querySelectorAll('script, style, iframe, object, embed').forEach((node) => node.remove());
    body.querySelectorAll('a').forEach((link) => {
      if (/^javascript:/i.test(link.getAttribute('href') || '')) link.removeAttribute('href');
    });

    details.append(summary, body);
    target.append(details);
  });

  if (!items.length) {
    const fallback = fragment.querySelector('.faq-container') || fragment;
    target.append(fallback.cloneNode(true));
  }

  target.hidden = false;
  root.dataset.ktFaqReady = 'true';
};

const initialiseAllFaqCenters = (scope = document) => {
  scope.querySelectorAll('[data-kt-faq-center]').forEach(initialiseFaqCenter);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialiseAllFaqCenters(), { once: true });
} else {
  initialiseAllFaqCenters();
}

document.addEventListener('shopify:section:load', (event) => initialiseAllFaqCenters(event.target));
